export const calculateProScore = ( values ) => {
  let score = 0;

  switch( values.levelOfEducation ) {
    case "No formal education":
      score += 5;
      break;
    case "Vocational qualification":
      score += 10;
      break;
    case "Associate's degree":
      score += 15;
      break;
    case "Bachelor's degree":
      score += 30;
      break;
    case "Master's degree":
      score += 40;
      break;
    case "Doctorate or higher":
      score += 50;
      break;
  }

  switch( values.organizationSeniority ) {
    case "Manager Level/Sergant":
      score += 10;
      break;
    case "Director Level/Back-Up":
      score += 15;
      break;
    case "VP/Captain":
      score += 20;
      break;
    case "Executive/Leader/Commander":
      score += 25;
      break;
    case "CEO/Chief/General":
      score += 30;
      break;
    case "Freelancer":
      score += 35;
      break;
    case "Founder":
      score += 40;
      break;
  }

  switch( values.professionalStanding ) {
    case "Emerging Talent":
      score += 5;
      break;
    case "Proven Professional":
      score += 10;
      break;
    case "Established Expert":
      score += 15;
      break;
    case "Industry Authority":
      score += 25;
      break;
    case "Industry Pioneer/Traiblazer":
      score += 50;
      break;
  }

  switch( values.yearsExperience ) {
    case "1-3":
      score += 5;
      break;
    case "4-6":
      score += 10;
      break;
    case "7-9":
      score += 20;
      break;
    case "10-14":
      score += 30;
      break;
    case "15-19":
      score += 40;
      break;
    case "20+":
      score += 50;
      break;
  }

  switch( values.recognition ) {
    case "Local/Regional Award":
      score += 5;
      break;
    case "General Industry Recognition":
      score += 10;
      break;
    case "National Award":
      score += 20;
      break;
    case "Highest Industry Award":
      score += 30;
      break;
    case "Government Honor":
      score += 50;
      break;
  }

  switch( values.pressCoverage ) {
    case "Local":
      score += 10;
      break;
    case "Regional":
      score += 20;
      break;
    case "National":
      score += 30;
      break;
    case "International":
      score += 50;
      break;
  }

  const ar = values.audienceReach
  if( ar < 500 ) { score += 0 }
  else if( ar < 1499 ) { score += 1 }
  else if( ar < 4999 ) { score += 2 }
  else if( ar < 9999 ) { score += 3 }
  else if( ar < 24999 ) { score += 4 }
  else if( ar < 49999 ) { score += 5 }
  else if( ar < 99999 ) { score += 6 }
  else if( ar < 249999 ) { score += 7 }
  else if( ar < 749000 ) { score += 8 }
  else if( ar < 750000 ) { score += 9 }
  else { score += 10 }

  switch( values.cameraPresence ) {
    case 1:
      score += 5;
      break;
    case 2:
      score += 10;
      break;
    case 3:
      score += 15;
      break;
    case 4:
      score += 20;
      break;
    case 5:
      score += 25;
      break;
    case 6:
      score += 30;
      break;
    case 7:
      score += 35;
      break;
    case 8:
      score += 40;
      break;
    case 9:
      score += 45;
      break;
    case 10:
      score += 50;
      break;
  }

  const es = values.communityEngagementScore
  if( es > 300 ) { score += 25 }
  else if( es > 200 ) { score += 20 }
  else if( es > 100 ) { score += 15 }
  else if( es > 50 ) { score += 10 }
  else if( es > 0 ) { score += 5 }

  switch( values.monetization ) {
    case "0%":
      score += 5;
      break;
    case "50%":
      score += 10;
      break;
    case "100%":
      score += 15;
      break;
  }

  return score;
}